import { render, staticRenderFns } from "./order-item-component.vue?vue&type=template&id=20de4396"
import script from "./order-item-component.vue?vue&type=script&lang=js"
export * from "./order-item-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports